import { StateInterface } from "./state";
import { AccessLogUserModel, InvoiceModel } from "../models";

export default {
  allInvoices(state: StateInterface): InvoiceModel[] {
    return state.invoices;
  },
  lastFive(state: StateInterface): InvoiceModel[] {
    return state.invoices
      .sort((a, b): number => {
        if (a.invoice_id > b.invoice_id) return -1;
        if (a.invoice_id < b.invoice_id) return 1;
        return 0;
      })
      .slice(0, 5);
  },
  allAccessLogs(state: StateInterface): AccessLogUserModel[] {
    return state.accessLogs;
  },
};
